import { render, staticRenderFns } from "./cancellation_policy.vue?vue&type=template&id=85a42afe&scoped=true&"
import script from "./cancellation_policy.vue?vue&type=script&lang=js&"
export * from "./cancellation_policy.vue?vue&type=script&lang=js&"
import style0 from "./cancellation_policy.vue?vue&type=style&index=0&id=85a42afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a42afe",
  null
  
)

export default component.exports